import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'es'];
  private languageChanged = new Subject<string>(); // Subject para emitir cambios de lenguaje

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService
  ) {
    let browserLang = 'en';
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    } else {
      this.setLanguage('en');
      browserLang = translate.getBrowserLang() ?? '';
    }
    translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
  }

  public setLanguage(lang: string) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
    this.languageChanged.next(lang); // Emitir el cambio de lenguaje
  }

  public getLanguage() {
    return this.cookieService.get('lang');
  }

  public onLanguageChange() {
    return this.languageChanged.asObservable(); // Método para suscribirse a los cambios de lenguaje
  }
}
